document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll('.scroll-animate-section, .scroll-animate, .dynamic-delay-section');

    const observerOptions = (threshold) => ({
        root: null, // The root is the viewport
        rootMargin: '0px', // No margin around the root
        threshold: threshold / 100 // Convert percentage to decimal
    });

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target.classList.contains('scroll-animate')) {
                    // Animate whole section
                    const delay = entry.target.getAttribute('data-delay') || 0;
                    setTimeout(() => {
                        entry.target.classList.add('visible');
                    }, delay);
                } else if (entry.target.classList.contains('scroll-animate-section')) {
                    // Animate individual elements within section with flexible settings
                    const elements = entry.target.querySelectorAll('.scroll-animate');
                    const sectionDelay = parseInt(entry.target.getAttribute('data-delay')) || 0;
                    setTimeout(() => {
                        elements.forEach((el, index) => {
                            const delay = el.getAttribute('data-delay') || index * 200;
                            setTimeout(() => {
                                el.classList.add('visible');
                            }, delay);
                        });
                    }, sectionDelay);
                } else if (entry.target.classList.contains('dynamic-delay-section')) {
                    // Animate individual elements within section with dynamic delays
                    const elements = entry.target.querySelectorAll('.scroll-animate');
                    const sectionDelay = parseInt(entry.target.getAttribute('data-delay')) || 0;
                    const delayIncrement = 200; // Default increment delay in ms
                    setTimeout(() => {
                        elements.forEach((el, index) => {
                            const delay = sectionDelay + (index * delayIncrement);
                            setTimeout(() => {
                                el.classList.add('visible');
                            }, delay);
                        });
                    }, sectionDelay);
                }
                observer.unobserve(entry.target); // Ensures the animation only happens once
            }
        });
    };

    sections.forEach(section => {
        const threshold = section.getAttribute('data-threshold') || 10; // Default to 10% if not set
        const observer = new IntersectionObserver(observerCallback, observerOptions(threshold));
        observer.observe(section);
    });
});